// frontend/src/components/Concierge/SettingsList.jsx
import React, { useState, useEffect } from "react";
import { List, ListItemButton, ListItemText, Divider, Box } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import SettingsPage from "./SettingsPage";

export default function SettingsList({ active, onSelect }) {
  const items = [
    { id: "bot", label: "Bot Messages" },
    { id: "fast", label: "Fast Responses" },
    { id: "auto", label: "Automations" },
    { id: "roles", label: "Roles & Permissions" },
    { id: "appearance", label: "Appearance" },
  ];

  const [selected, setSelected] = useState(active || "bot");
  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    function handler() {
      setIsOpen(true);
    }
    window.addEventListener("openSettingsList", handler);
    return () => {
      window.removeEventListener("openSettingsList", handler);
    };
  }, []);

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <Collapse
        in={isOpen}
        orientation="horizontal"
        collapsedSize={0}
        sx={{ borderRight: "1px solid #eee", overflow: "hidden" }}
      >
        <List sx={{ width: 300, borderRight: "none", overflow: "hidden" }}>
          {items.map((it, i) => (
            <React.Fragment key={it.id}>
              <ListItemButton
                selected={selected === it.id}
                onClick={() => {
                  setSelected(it.id);
                  onSelect?.(it.id);
                  setIsOpen(false);
                }}
              >
                <ListItemText primary={it.label} />
              </ListItemButton>
              {i < items.length - 1 && <Divider />}
            </React.Fragment>
          ))}
        </List>
      </Collapse>
      <Box sx={{ flexGrow: 1, transition: "all 200ms ease", minWidth: 0 }}>
        <SettingsPage active={selected} />
      </Box>
    </Box>
  );
}